import React from 'react';

class Index extends React.Component {
	render() {
		return (
			<div className="container">
				<h1>vovkabelov.ru</h1>
			</div>
		)
	}
}

export default Index;


// WEBPACK FOOTER //
// ./src/index/index.js